import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { QpxButton, QpxIcon } from '@quipex/shared/ui';

@Component({
    selector: 'qpx-suggestion-pagination',
    imports: [NgIcon, QpxButton, QpxIcon],
    templateUrl: './suggestion-pagination.html',
    styleUrl: './suggestion-pagination.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestionPagination {
    public readonly currentPage = input.required<number>();
    public readonly totalPages = input.required<number>();
    public readonly previous = output<void>();
    public readonly next = output<void>();
    public readonly pageSelected = output<number>();
    protected readonly pageNumbers = computed(() =>
        Array.from({ length: this.totalPages() }, (_, index) => index + 1)
    );
}
